import styled from 'styled-components';

export const StoreButtonStyled = styled.a`
    border-radius: 4px;
    background-color: var(--color-surface-secondary);
    padding: 16px 10px;
    border: none;
    display: flex;
    width: 100%;
    text-decoration: none;

    &:hover {
        background-color: var(--color-surface);
    }
`;

export const StoreButtonNameContainerStyled = styled.div`
    display: flex;
    flex-direction: column;
    color: var(--color-white);
    margin-left: 8px;
`;

export const StoreButtonDownloadStyled = styled.span`
    font-size: 14px;
    line-height: 21px;
    font-weight: 400;
    text-align: left;
`;

export const StoreButtonNameStyled = styled.span`
    font-size: 20px;
    line-height: 30px;
    font-weight: 700;
    text-align: left;
`;
